import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/developer-platform/page.tsx");
